<template>
  <v-container fluid pa-0 mt-0 pt-1>
    <v-row>
      <v-col><slot></slot></v-col>
    </v-row>
    <itinerary-builder-items-group
      v-for="(groupKey, index) of Object.keys(groups)"
      :key="groupKey"
      :index-no="index"
      :group="groups[groupKey]"
      :headers="headers"
      :visible-columns="visibleColumns"
      :currencyCode="currencyCode"
      :basic-comps="basicComps"
      @onRecalculate="onRecalculate"
      @action="onAction"
      @supplier-edit="$emit('supplier-edit', $event)"
      :flagsEditDisabledFn="flagsEditDisabledFn"
      @showMoveDays="onShowMoveDays"
      @reorderSelectedServices="onReorderSelectedServices"
      @customPriceToggle="onCustomPriceToggle"
      @zeroSelectedServices="onZeroSelectedServices"
      @showPaxUpdater="onShowPaxUpdater"
      @removeSelectedServices="onRemoveSelectedServices"
      @showUpdateStatus="onShowUpdateStatus"
      @showItiComps="onShowItiComps"
      @showRemarksEdit="onShowRemarksEdit"
      @showPriceAdjuster="onShowPriceAdjuster"
      @orderNoChange="onOrderNoChange"
      @refreshPrices="onRefreshPrices"
      @timeChange="onTimeChange"
      @isIncludedChange="onIsIncludedChange"
      @isOptionalChange="onIsOptionalChange"
      :search="search"
    />
  </v-container>
</template>

<script>
import ItineraryBuilderItemsGroup from "./ItineraryBuilderItemsGroup";
import { sortByDateField } from "../../../../helpers";
export default {
  name: "ItineraryBuilderItemsListGrouped",
  props: {
    visibleColumns: {
      type: Array,
      default: () => {},
    },
    group: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    currencyCode: {
      type: String,
      default: () => "",
    },
    flagsEditDisabledFn: {
      type: Function,
      default: (item) => false,
    },
    basicComps: {
      type: Boolean,
      default: () => true,
    },
    search: {
      type: String,
      default: "",
    },
  },
  components: {
    ItineraryBuilderItemsGroup,
  },
  data() {
    return {
      debug: false,
    };
  },
  computed: {
    groups() {
      return this.groupBy(this.group);
    },
  },
  methods: {
    onShowPriceAdjuster(payload) {
      this.$emit("showPriceAdjuster", payload);
    },
    groupBy(group) {
      const sortedByDate = this.items.sort(sortByDateField("startDate"));
      return sortedByDate.reduce((h, item) => {
        const key = item[group.fieldName];
        if (!h[key]) {
          h[key] = { label: key, fieldName: group.fieldName, items: [] };
        }
        h[key].items.push(item);
        return h;
      }, {});
    },
    onRecalculate() {
      console.log("grouped onRecalculate");
      this.$emit("onRecalculate");
    },
    onAction(payload) {
      this.$emit(payload.action, payload.payload);
    },
    onShowMoveDays(payload) {
      this.$emit("showMoveDays", payload);
    },
    onReorderSelectedServices(payload) {
      this.$emit("reorderSelectedServices", payload);
    },
    onCustomPriceToggle(payload) {
      this.$emit("customPriceToggle", payload);
    },
    onZeroSelectedServices(payload) {
      this.$emit("zeroSelectedServices", payload);
    },
    onShowPaxUpdater(payload) {
      this.$emit("showPaxUpdater", payload);
    },
    onRemoveSelectedServices(payload) {
      this.$emit("removeSelectedServices", payload);
    },
    onShowUpdateStatus(payload) {
      this.$emit("showUpdateStatus", payload);
    },
    onShowItiComps(payload) {
      this.$emit("showItiComps", payload);
    },
    onShowRemarksEdit(payload) {
      this.$emit("showRemarksEdit", payload);
    },
    onItemsListAction(payload) {
      this.$emit("action", payload);
    },
    onOrderNoChange(payload) {
      this.$emit("orderNoChange", payload);
    },
    onRefreshPrices(payload) {
      this.$emit("refreshPrices", payload);
    },
    onTimeChange(payload) {
      this.$emit("timeChange", payload);
    },
    onIsIncludedChange(payload) {
      this.$emit("isIncludedChange", payload);
    },
    onIsOptionalChange(payload) {
      this.$emit("isOptionalChange", payload);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/ItineraryBuilderItemsListGrouped.vue